import { defineComponent as _defineComponent } from 'vue'
import { agenda } from '@/store'


const __default__ = {
	model: {
		prop: 'mostra',
	},
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'LegendaDaAgenda',
  props: {
	mostra: { default: true, type: Boolean },
},
  emits: ["input"],
  setup(__props) {





const legendas = {
	grau: [
		{
			descricao: 'Grau 1',
			cor: 'green',
		},
		{
			descricao: 'Grau 2',
			cor: 'orange',
		},
		{
			descricao: 'Grau 3',
			cor: 'red',
		},
		{
			descricao: 'Reuniões',
			cor: 'primary',
		},
	],
	tipo: [
		{
			descricao: 'Ordinária',
			cor: 'green',
		},
		{
			descricao: 'Magna',
			cor: 'orange',
		},
		{
			descricao: 'Finanças / Extraordinária',
			cor: 'red',
		},
		{
			descricao: 'Pública',
			cor: 'black',
		},
		{
			descricao: 'Reuniões',
			cor: 'secondary',
		},
	],
}

return { __sfc: true,legendas, agenda }
}

})